import { format } from "date-fns";
import { ShippingTypeEnum } from "./types";

export const PRIMARY_HEX: string = "#613F4F";

export const ACCENT_HEX: string = "#F6D040";

export const LINK_BLUE_HEX: string = "#3c7dd9";

export const CYCLE_BANNER_CLASS_NAME: string =
  "overflow-hidden rounded-xl border border-[#613F4F]/30 bg-gradient-to-r from-[#613F4F]/5 to-[#F6D040]/10 shadow-sm";

export const APPROVED_HIGHLIGHT_CLASS_NAME: string = "text-green-700";

export const CASES_DIFF_CLASS_NAME: string = "text-amber-700";

export const ISO_DATE_FORMAT: string = "yyyy-MM-dd";

export const todayISO = (): string => format(new Date(), ISO_DATE_FORMAT);

export const EMPTY_RANGE = { start: "", end: "" } as const;

export const HISTORY_DEFAULT_WINDOW_DAYS: number = 30;

export const HISTORY_PAGE_SIZE: number = 10;

export const FIRST_PAGE: number = 1;

export const SHIPPING_KIND_LABELS: Record<ShippingTypeEnum, string> = {
  [ShippingTypeEnum.HR_EMAIL]: "Email para RH",
  [ShippingTypeEnum.RANKINGS_SPREADSHEET]: "Planilha Rankings",
  [ShippingTypeEnum.LOSS_SPREADSHEET]: "Planilha Perdas",
};

export const SHIPPING_KIND_BADGE_CLASS_NAME: Record<ShippingTypeEnum, string> = {
  [ShippingTypeEnum.HR_EMAIL]: "bg-teal-50 text-teal-700 border-teal-200",
  [ShippingTypeEnum.RANKINGS_SPREADSHEET]:
    "bg-amber-50 text-amber-700 border-amber-200",
  [ShippingTypeEnum.LOSS_SPREADSHEET]:
    "bg-purple-50 text-purple-700 border-purple-200",
};

export const HISTORY_COLUMN_TITLES = {
  SENT_AT: "Data / Hora",
  KIND: "Tipo",
  RECIPIENTS: "Destinatários",
  STATUS: "Status",
  ACTION: "Ação",
} as const;

export const EXPORT_ITEM_LABELS = {
  CASH_LOSSES: "Perdas de Caixa",
  PAYROLL_DISCOUNTS: "Descontos em Folha",
  PAYROLL_SENIOR_SHEET: "Planilha Desconto em Folha (Sênior)",
  CONSOLIDATED_LOSSES: "Consolidada Perdas",
  CONSOLIDATED_PAYROLL: "Consolidada Folha",
} as const;

export const FISCAL_CYCLE_END_DAY: string = "25";

export const MANAGE_LOSS_PATH: string = "/conciliacao/gerenciar-perdas";

export const MANAGE_LOSS_FILTERS_STORAGE_KEY: string = "manage-loss-filters";

export const IS_LOSS_FILTER_VALUE: string = "true";

export const PAYROLL_DISCOUNT_FILTER_VALUE: string = "false";
